import '../Grid.less';
import cn from 'classnames';
import React, { FC, ReactNode } from 'react';

interface IProps {
    menuOpen: boolean;
    closeMenu: () => void;
    children?: ReactNode;
}

const LeftColumn: FC<IProps> = ({ menuOpen = false, closeMenu, children = null }) => {
    const className = cn('grid__left-column', {
        open: menuOpen,
    });

    return (
        <div className={className}>
            <div className="grid__sticky">
                <div className="grid__left-column__inner">{children}</div>
            </div>
            <div className="grid__left-column__overlay" onClick={() => closeMenu()} />
        </div>
    );
};

export default LeftColumn;
